<template>
    <div class="ai-client-content">
        <template v-if="hasData">
            <AIContentList
                v-if="hasKeyDates"
                class="ai-client-content__key-dates"
                :hasMargin="purchaseBehavior.total_purchase_amount > 0"
            >
                <h4 class="typographies-paragraph-medium-semibold">
                    {{ $t.__('overview.tabs.TabSummary.clientContent.key_dates') }}
                </h4>
                <ul>
                    <li>
                        {{
                            $t.__('overview.tabs.TabSummary.clientContent.first_purchase', {
                                date: formattedFirstPurchaseDate,
                            })
                        }}
                    </li>
                    <li>
                        {{
                            $t.__('overview.tabs.TabSummary.clientContent.last_purchase', {
                                date: formattedLastPurchaseDate,
                            })
                        }}
                    </li>
                </ul>
            </AIContentList>
            <p
                v-if="purchaseBehavior.total_purchase_amount > 0"
                class="ai-client-content__total-purchase-amount"
            >
                <span class="typographies-paragraph-medium-semibold">
                    {{ $t.__('overview.tabs.TabSummary.clientContent.total_amount') }} :
                </span>
                {{ $filters.numberFormatCurrency(purchaseBehavior.total_purchase_amount) }}
            </p>
        </template>
        <NoInvoicingData v-else />
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import NoInvoicingData from 'vcomponents/AISummary/Content/NoInvoicingData.vue';
import AIContentList from 'vcomponents/AISummary/Content/AIContentList.vue';

const { mapState: corpMapState } = createNamespacedHelpers('corp');

export default {
    components: {
        NoInvoicingData,
        AIContentList,
    },
    inject: ['getSummary'],
    computed: {
        ...corpMapState(['timeformat']),
        summary() {
            return this.getSummary();
        },
        purchaseBehavior() {
            return this.summary
                ? this.summary.summary.input.customer_summary.purchase_behaviour
                : {};
        },
        hasKeyDates() {
            return this.purchaseBehavior?.last_purchase_date;
        },
        formattedLastPurchaseDate() {
            return this.purchaseBehavior.last_purchase_date
                ? this.formatDate(this.purchaseBehavior.last_purchase_date)
                : '';
        },
        formattedFirstPurchaseDate() {
            return this.purchaseBehavior.first_purchase_date
                ? this.formatDate(this.purchaseBehavior.first_purchase_date)
                : '';
        },
        hasData() {
            return this.hasKeyDates && this.purchaseBehavior.total_purchase_amount > 0;
        },
    },
    methods: {
        formatDate(date) {
            return this.timeformat === 'dmy'
                ? moment(date).format('DD/MM/YYYY')
                : moment(date).format('MM/DD/YYYY');
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-client-content {
    &__key-dates {
        h4 {
            margin: 0;
        }

        ul {
            list-style-type: none;
            margin: 0;
            padding: 0;
        }
    }

    &__total-purchase-amount {
        margin: 0;
    }
}
</style>
